import React, { Component } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Checkbox,
  CardMedia,
  IconButton,
  CardActionArea,
  Menu,
  MenuItem,
  Icon,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, pick } from 'lodash-es';
import ImagePlaceholder from '../../assets/img/image-placeholder.png';
import {
  showTwoDecimalsForMoney,
} from '../../utils/Functions';
import { getLocations } from '../../selectors';
import { displayResourceStyles, productCardStyle } from '../../css/style';
import { productFields, CARD_MENU_POSITION } from '../../data/Constants';

const styles = productCardStyle();
const displayStyles = displayResourceStyles();
class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      anchorEl: null,
    };
  }

  getAndFormatPrice = () => {
    const { product } = this.props;
    const defaultItem = product.items.filter(item => item.isDefault);
    if (!defaultItem[0]) {
      return '';
    }
    return `$${showTwoDecimalsForMoney(defaultItem[0].price)}`;
  }

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null, isMenuOpen: false });
  }

  onClickDelete = async () => {
    const { onClickDelete } = this.props;
    onClickDelete();
    this.handleMenuClose();
  }

  updateProductFields = async (data, isAvailable) => {
    const { actions, apiToken } = this.props;
    const productCopy = pick(data, productFields);
    if (!get(productCopy, 'description')) {
      productCopy.description = '';
    }
    productCopy.isDisabled = isAvailable;
    actions.updateResource(apiToken, productCopy, 'products', data.id).then(() => {
      actions.getAllResources(apiToken, 'products');
    });
  }

  onClickEnable = async (data) => {
    if (data.isDisabled === true) {
      this.updateProductFields(data, false);
    }
    this.handleMenuClose();
  }

  onClickDisable = async (data) => {
    if (data.isDisabled === false) {
      this.updateProductFields(data, true);
    }
    this.handleMenuClose();
  }

  onClickDuplicate = (data) => {
    const {
      actions,
      apiToken,
      onClickDuplicate,
    } = this.props;
    const resourcePath = ['products', data.id, 'duplicate'];
    actions.duplicateResource(apiToken, resourcePath).then(() => {
      onClickDuplicate();
      this.handleMenuClose();
    });
  };

  getLocationsDisplayValue = (isOutOfStock, locations) => {
    const { product } = this.props;
    let filteredLocations = [];
    if (!Array.isArray(locations) || !Array.isArray(product.locations)) return '';

    if (isOutOfStock) {
      const isOOSEmpty = product.outOfStockLocations && product.outOfStockLocations.length === 0;
      if (!product.outOfStock || isOOSEmpty) return 'None';
      filteredLocations = product.outOfStockLocations
        && product.outOfStockLocations.map((locationId) => {
          const locationInfo = locations.find(location => `${location.id}` === `${locationId}`);
          if (!locationInfo || !locationInfo.name) return '';
          return locationInfo.name;
        });
    } else {
      filteredLocations = product.locations && product.locations.map((locationId) => {
        const locId = get(locationId, 'id', locationId);
        const locationInfo = locations.find(location => `${location.id}` === `${locId}`);
        if (!locationInfo || !locationInfo.name) return '';
        return locationInfo.name;
      });
    }

    const filteredList = filteredLocations.filter(name => !!(name));
    if (filteredList.length === locations.length || filteredList.length === 0) {
      return 'All locations';
    }
    return filteredList.join('\n\r');
  }

  onCheck = (event, product) => {
    const { actions } = this.props;
    if (event.target.checked) {
      actions.selectItems([product]);
    } else {
      actions.unselectItem(product);
    }
  }

  getStyleName = (style, isDisabled) => (
    isDisabled ? styles[`${style}DisabledStyle`] : styles[`${style}Style`]
  );

  render() {
    const {
      product,
      onClickEdit,
      locations,
      isChecked,
    } = this.props;
    const { anchorEl, isMenuOpen } = this.state;
    const isDisabled = product.isDisabled ? product.isDisabled : null;
    return (
      <Card style={styles.cardStyle}>
        <CardContent style={styles.cardContentStyle}>
          <div style={styles.cardContentChildStyle}>
            <Checkbox
              style={styles.checkBoxStyle}
              checked={isChecked(product)}
              onChange={event => this.onCheck(event, product)}
              icon={(
                <Icon style={displayStyles.uncheckedCheckboxIcon}>
                  check_box_outline_blank
                </Icon>
              )}
              checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
            />
            <CardActionArea onClick={onClickEdit} style={styles.cardActionAreaStyle}>
              <div style={styles.actionAreaStyle}>
                <div style={styles.imageContainerStyle}>
                  <CardMedia
                    src={product.images[0] ? product.images[0].src : ImagePlaceholder}
                    component='img'
                    style={isDisabled ? styles.disabledImageStyle : styles.imageStyle}
                  />
                  {
                    isDisabled && (
                      <div style={styles.disabledTextStyle}>
                        DISABLED
                      </div>
                    )
                  }
                </div>
                <Typography style={this.getStyleName('nameText', isDisabled)}>
                  {product.name}
                </Typography>
                <Typography style={this.getStyleName('locationsText', isDisabled)}>
                  {this.getLocationsDisplayValue(false, locations)}
                </Typography>
                <Typography style={this.getStyleName('locationsText', isDisabled)}>
                  {this.getLocationsDisplayValue(true, locations)}
                </Typography>
                <Typography style={this.getStyleName('priceText', isDisabled)}>
                  {this.getAndFormatPrice()}
                </Typography>
              </div>
            </CardActionArea>
            <IconButton
              style={styles.threeDotStyle}
              onClick={event => this.handleMenuOpen(event)}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id={product.id}
              open={isMenuOpen}
              anchorEl={anchorEl}
              onClose={() => this.handleMenuClose()}
              getContentAnchorEl={null}
              anchorOrigin={CARD_MENU_POSITION}
              transformOrigin={CARD_MENU_POSITION}
            >
              <MenuItem onClick={onClickEdit}>Edit</MenuItem>
              <MenuItem onClick={() => this.onClickDuplicate(product)}>Duplicate</MenuItem>
              {
                isDisabled ? (
                  <MenuItem onClick={() => this.onClickEnable(product)}>Enable</MenuItem>
                ) : (
                  <MenuItem onClick={() => this.onClickDisable(product)}>Disable</MenuItem>
                )
              }
              <MenuItem onClick={() => this.onClickDelete(product)}>Delete</MenuItem>
            </Menu>
          </div>
        </CardContent>
      </Card>
    );
  }
}

ProductCard.propTypes = {
  product: PropTypes.objectOf(PropTypes.any).isRequired,
  onClickDelete: PropTypes.func.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickDuplicate: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  isChecked: PropTypes.func.isRequired,
};

ProductCard.defaultProps = {
  locations: null,
};

const mapStateToProps = state => ({
  locations: getLocations(state),
});

export default connect(mapStateToProps)(ProductCard);
